<template>
  <div class="bg-[#f4f5f8] m-0 min-h-screen register-main-wrapper">
    <div class="text-container">
      <p class="title">{{ $t("youdonothaveaccess") }}.</p>
      <a :href="CABINET_URL">
        <button class="btn">{{ $t("backToHome") }}</button>
      </a>
    </div>
  </div>
</template>

<script>
import { CABINET_URL } from "@/config";
export default {
  name: "forbidden",
  data() {
    return {
      CABINET_URL,
    };
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap");

.register-main-wrapper {
  display: grid;
  place-items: center;
  margin-top: 110px;
  min-height: calc(100vh - 56px);
  width: 100%;
  background: url("../../assets/img/background1.png") no-repeat center fixed;
  background-size: cover;
  font-family: "Rubik", sans-serif;
}

.title {
  color: #fff;
  font-weight: 600;
  font-size: 36px !important;
  line-height: 44px;
  font-family: "Rubik", sans-serif !important;
  text-align: center;
}

.text-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  align-items: center;
}

.btn {
  background: #fff;
  color: #000;
  border-radius: 6px;
  padding: 6px 8px;
  border: 1px solid #ababab;
  transition: 0.3s all ease;
  font-size: 13px;

  &:hover {
    border: 1px solid #0096b2;
    color: #0096b2;
  }
}
</style>
